import { decryptInteger } from "@/Utils/encryptInteger";
import { PaymentElement, useElements, useStripe } from "@stripe/react-stripe-js";
import { useEffect, useState } from "react";
import toast from "react-hot-toast";

const CheckoutForm = () => {
    const stripe = useStripe();
    const elements = useElements();
    const [data, setData] = useState()

    const handleSubmit = async (event) => {
        event.preventDefault();

        if (!stripe || !elements) {
            console.error("Stripe or Elements is not loaded yet");
            toast.error("Payment system not ready. Please try again.");
            return;
        }

        const { error } = await stripe.confirmPayment({
            elements,
            confirmParams: {
                return_url: `${window.location.origin}/payment-success`
            }
        });

        if (error) {
            console.error("Error processing payment:", error)
            toast.error(error.message);
        }
    };

    const fetchProfileInfo = async () => {
        try {
            let web_token = "";
            const encryptedData = localStorage.getItem("user_data");
            if (encryptedData) {
                const decryptedString = decryptInteger(encryptedData);
                const userData = JSON.parse(decryptedString);

                const expiresAt = new Date(userData.web_token_expires_at).getTime();
                if (Date.now() > expiresAt) {
                    toast.error("Seestion expired, Please Login Again..")
                    localStorage.removeItem("user_data");
                } else {
                    web_token = userData.web_token;
                    const formdata = new FormData();
                    formdata.append("action", "fetchProfileInfo");

                    const response = await fetch(`${process.env.NEXT_PUBLIC_BACKEND_URL}/webapi/manageUserData`, {
                        method: "POST",
                        headers: {
                            "Authorization": `Bearer ${web_token}`
                        },
                        body: formdata
                    });

                    const data = await response.json();
                    if (data.status) {
                        const values = data.data;
                        let obj = {
                            name: values.name ?? "",
                            email: values.email ?? "",
                        }
                        setData(obj);

                    } else {
                        console.error("Error fetching profile info");
                    }
                }
            }

        } catch (error) {
            console.error("Error fetching profile info:", error)
        }
    }

    useEffect(() => {
        fetchProfileInfo();
    }, [])


    return (
        <form >
            <PaymentElement options={{
                defaultValues: {
                    billingDetails: {
                        email: data?.email,
                        name: data?.name
                    }
                }
            }} />
            <div className="flex justify-end gap-3 items-center">
                <button
                    type="button"
                    className="w-[220px] py-2 rounded-md bg-[#8f8f8f] mt-4 text-center"
                    onClick={() => window.location.reload()}
                >
                    Cancel Payment
                </button>
                <button onClick={handleSubmit} className="w-[220px] py-2 rounded-md bg-[#fa2cb4] mt-4 text-center " disabled={!stripe}>Pay Now</button>
            </div>
        </form>
    );
};

export default CheckoutForm;